import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PushSubscriptionService {

  constructor(private apiService: ApiService) { }

  saveSubscription(sub) {
    return this.apiService.post('/api/pushsubscription?pushSubscription=' + JSON.stringify(sub), sub);
  }
}
